export default "__VITE_ASSET__CuhQ2Euz__"